const getters = {
  device: state => state.app.device
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js